import { css } from '@migros/msrc-ui-kit';
export const mgbRatingStyles = css`
  color: ${({
  active,
  theme: {
    colors
  }
}) => {
  var _colors$brand$special;
  return active ? ((_colors$brand$special = colors.brand.specialRialtoRatingsColor) === null || _colors$brand$special === void 0 ? void 0 : _colors$brand$special[100]) || colors.brand.primary[100] : colors.tints.gray[25];
}};
  &:hover {
    color: ${({
  active,
  editable,
  theme: {
    colors
  }
}) => {
  var _colors$brand$special2;
  return editable && !active && (((_colors$brand$special2 = colors.brand.specialRialtoRatingsColor) === null || _colors$brand$special2 === void 0 ? void 0 : _colors$brand$special2[100]) || colors.brand.primary[100]);
}};
  }
`;